import multiDownload from "multi-download";
// const isTouchDevice = window.matchMedia("(pointer:coarse)");
const isTouchDevice = false;
const hasMultiDownload = !isTouchDevice;

let count_dreams = 0;

let urls = [];
const triggers = document.querySelectorAll(".js-dl-trigger");
const downloadModal = document.querySelector(".modal-telecharger-reves");
const downloadCount = document.querySelector(".button--selected-number p");
const downloadButton = document.querySelector("#modal-telecharger-button");
const selectAllButton = document.querySelector(".modal-tout-selectionner");
const closeModalButton = document.querySelector("#dl-close-button");

if (!hasMultiDownload) {
  triggers &&
    triggers.forEach((trigger) => {
      // set initial selection status
      let isSelected = false;
      // get pdf url
      const pdf_url = trigger.dataset.url;
      trigger.addEventListener("click", function () {
        // style the trigger
        trigger.classList.toggle("is-selected");
        // register selection status
        isSelected = !isSelected;
        // update count
        isSelected ? count_dreams++ : count_dreams--;
        // add or remove url according to selection status
        if (isSelected) {
          urls.push(pdf_url);
        } else {
          urls = urls.filter((u) => u !== pdf_url);
        }
        // show modal
        downloadModal.classList.add("is-visible");
        // show count
        downloadCount.innerHTML = count_dreams;
        // hide modal if none selected
        if (!count_dreams) {
          downloadModal.classList.remove("is-visible");
        }
        // (de)select download all
        if (count_dreams === triggers.length) {
          selectAllButton.classList.add("is-selected");
        } else {
          selectAllButton.classList.remove("is-selected");
        }
      });
    });

  selectAllButton &&
    selectAllButton.addEventListener("click", function () {
      urls = [];
      triggers.forEach((trigger) => {
        if (!trigger.classList.contains("is-selected")) {
          trigger.click();
        }
      });
      selectAllButton.classList.add("is-selected");
      count_dreams = triggers.length;
      downloadCount.innerHTML = count_dreams;
      console.log(count_dreams + "/" + urls.length);
    });

  closeModalButton &&
    closeModalButton.addEventListener("click", function () {
      triggers.forEach((trigger) => {
        if (trigger.classList.contains("is-selected")) {
          trigger.click();
        }
      });
      downloadModal.classList.remove("is-visible");
    });
  downloadButton &&
    downloadButton.addEventListener("click", function (e) {
      multiDownload(urls);
    });
}

if (hasMultiDownload) {
  triggers &&
    triggers.forEach((trigger) => {
      // set initial selection status
      let isSelected = false;
      // get pdf url
      const pdf_url = trigger.dataset.url;
      trigger.addEventListener("click", function () {
        // style the trigger
        trigger.classList.add("is-selected");

        window.open(trigger.dataset.url, "_blank");
        trigger.classList.remove("is-selected");
      });
    });
}

// todo
// - clear selection on filtering
